import React from 'react';
import TemplateTableRow from './Templatetablerow';

const TemplatesTable = ({ templates = [], loading = false, onEdit, onDelete, isProActive }) => {
  if (loading) {
    return (
      <div className="space-y-3 mt-6">
        {[...Array(10)].map((_, index) => (
          <div
            key={index}
            className="h-14 bg-gray-100 rounded-xl animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (templates.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center mt-6">
        <div className="text-7xl mb-6 opacity-70">📝</div>
        <h3 className="text-xl font-semibold text-[#17171C] mb-3">
          No Templates Found
        </h3>
        <p className="text-[#6F6F7B] max-w-md">
          No templates match your search criteria.
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto bg-white mt-6">
      <table className="w-full min-w-[900px]">
        <thead>
          <tr className="h-12 border border-[#E4E4E7]">
            <th className="text-left py-4 px-6 text-xs font-semibold text-[#6F6F7B] uppercase tracking-wider w-20">
              ID
            </th>
            <th className="text-left py-4 px-6 text-xs font-semibold text-[#6F6F7B] uppercase tracking-wider">
              Template Name
            </th>
            <th className="text-left py-4 px-6 text-xs font-semibold text-[#6F6F7B] uppercase tracking-wider w-32">
              Type
            </th>
            <th className="text-right py-4 px-6 text-xs font-semibold text-[#6F6F7B] uppercase tracking-wider w-32">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-[#E4E4E7]">
          {templates.map((template) => (
            <TemplateTableRow
              key={template.id}
              template={template}
              onEdit={onEdit}
              onDelete={onDelete}
              isProActive={isProActive}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TemplatesTable;